import React, { useContext } from 'react';
import styles from './style.css';
import SectionHeading from '../Typography/SectionHeading/SectionHeading';
import EditButton from '../Typography/EditButton/EditButton';
import { FlowContext } from '../../core/flow-engine';
import {
  formatFundingInfo,
  displayTaxableYear,
  taxableYearsToShow
} from './utils';

const FundingDetails = ({ fundingInfo, store }) => {
  return (fundingInfo || []).map(account => {
    return (
      <div className="row" key={account.accountNumber}>
        {account.accountName}
        {` ${account.accountNumber}${
          account.accountName === 'Check' ? '' : ' / '
        }`}

        {displayTaxableYear(store) ? (
          <>{taxableYearsToShow(store)}</>
        ) : (
          <>${account.estimatedAmount}</>
        )}

        <style jsx>{styles}</style>
      </div>
    );
  });
};

const ReviewEditFunding = ({ handleClick, shouldAllowEditing = true }) => {
  const { appState } = useContext(FlowContext);
  const { store } = appState;
  const fundingInfo = formatFundingInfo(store);

  return (
    <div data-name="reviewEditFunding" className="review-customer-information">
      <SectionHeading text="My Funding">
        {shouldAllowEditing && <EditButton onClick={handleClick('funding')} />}
      </SectionHeading>
      <div className="my-portoflio">
        <FundingDetails fundingInfo={fundingInfo} store={store} />
      </div>
      <style jsx>{styles}</style>
    </div>
  );
};

export default ReviewEditFunding;
